import { render } from "./ModalCodeVerify.vue?vue&type=template&id=2564f503&scoped=true"
import script from "./ModalCodeVerify.vue?vue&type=script&lang=js"
export * from "./ModalCodeVerify.vue?vue&type=script&lang=js"

import "./ModalCodeVerify.vue?vue&type=style&index=0&id=2564f503&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2564f503"]])

export default __exports__